import { Box, Typography, Avatar } from "@mui/material";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
export default function FormHeader({ title, description }) {
  return <Box sx={{ textAlign: "center" }}>
    <Avatar variant="rounded" sx={{ width: 52, height: 52, mx: "auto", mb: 2, bgcolor: "primary.light", color: "primary.main", borderRadius: 2 }}><RestaurantOutlinedIcon /></Avatar>
    <Typography component="h1" variant="h5" sx={{ mb: .75 }}>{title}</Typography>
    {description && <Typography variant="body2" color="text.secondary">{description}</Typography>}
  </Box>;
}
